import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar';
const {onModeEnter, onModeLeave, getMode} = require('./media.js');

export default class StickyRegSideBar {

    constructor (options) {
        this.options = $.extend({
            node: '.user-api--search',
            selectorPrefix: '',
            threshold: 75
        }, options);

        //     let $sticky = this.options.node,
        //     if (scroll > this.options.threshold){

        this._initStickySidebar();
    }

    _enableStickySidebar() {
        console.log(this.options.selectorPrefix + '.user-api--wrapper');
        this.sidebar = new StickySidebar(this.options.selectorPrefix + this.options.node, {
            topSpacing: this.options.threshold,
            bottomSpacing: this.options.threshold,
            containerSelector: this.options.selectorPrefix + '.user-api--wrapper',
            innerWrapperSelector: this.options.selectorPrefix + '.stixty-content',
            resizeSensor: true,
            stickyClass: 'is-affixed',
        });
    }

    _disableStickySidebar() {
        this.sidebar.destroy();
    }

    _initStickySidebar(){
        console.log('init')
        if( getMode() == 'desktop' ){
            this._enableStickySidebar();
        }

        onModeEnter('desktop', () => {
            this._enableStickySidebar();
            console.log('init')
        });

        onModeLeave('desktop', () => {
            this._disableStickySidebar();
        });
    }

    _reinitStickySidebar(){
        if( getMode() == 'desktop' ){
            this.sidebar.updateSticky();
        }
        console.log('update')
    }

};